import {TFunction} from 'i18next';
import {IContentMeta, ILabel, IVideo} from '../../common/type';
import {PageInfo} from '../../common/util/PageRouter';
import {IBigContent} from '../../commonSub/type';
import {IMainSecondTab} from '../main/type';
import {IMyPageSecondTab} from '../myPage/type';
import {ITimeTableSecondTab} from '../timeTable/type';

export enum HomeTabPage {
  Main = '',
  TimeTable = 'original-webtoon',
  MyPage = 'my-page',
}

export interface ITabItem {
  tabPage: HomeTabPage;
  title: (t: TFunction) => string;
}

export interface ISecondTabItem {
  key: ISecondTabKey;
  text: string;
}

export type ISecondTabs = {
  [HomeTabPage.Main]: ISecondTab<IMainSecondTab | string>;
  [HomeTabPage.MyPage]: ISecondTab<IMyPageSecondTab>;
  [HomeTabPage.TimeTable]: ISecondTab<ITimeTableSecondTab>;
};

export type ISecondTabKey = ISecondTabs[keyof ISecondTabs]['selected'];

export interface ISecondTabKeyMap<T> {
  key: T;
  text: string;
}

interface ISecondTab<T> {
  selected: T;
  tabList: Array<ISecondTabKeyMap<T>>;
}

export interface IMessageProps {
  onFinish?: () => void;
}

export interface IEventPopup {
  id: number;
  title: string;
  date: string;
  popupImgUrl: string;
  landingUri: string;
  buttonTitle: string;
}

export interface INoticePopup {
  id: string;
  title: string;
  date: string;
  content: string;
  buttonTitle: string;
  isMaintenance?: boolean;
}

export interface IMainItem {
  id: string;
  tag: string;
  placement: string;
  moduleType: string;
  title?: string;
  bigContent?: IBigOverContent;
  contents?: IMainContent[];
  showRankingInfo: boolean;
  isAdminSection: boolean;
}
interface IMainContentProps
  extends IMainAdditionalProps,
    Pick<IContentMeta, 'id' | 'sid' | 'title' | 'bgImg' | 'badges'> {}
export interface IMainAdditionalProps extends IRankingInfo {
  label: ILabel;
  landingUrl?: string | PageInfo;
  isEvent?: boolean;
  operationId?: string;
  landingType?: 'EVENT_PAGE' | 'CONTENT';
  eventIpVideo?: IVideo;
  blackBadgeList?: string[];
}
export interface IBigOverContent
  extends IBigContent,
    Omit<IMainAdditionalProps, 'label'> {
  showAuthors: boolean;
  titleText?: string;
}
export interface IMainContent
  extends IMainContentProps,
    Pick<IContentMeta, 'thumbImg' | 'titleImg' | 'bgColor' | 'bgColorRgb'> {}

export interface IMainParams<T = IBigOverContent | IMainContent> {
  item: IMainItem;
  content: T;
  index: number;
}
export type IMainItemHandler<T = IBigOverContent | IMainContent> = (
  params: IMainParams<T>
) => void;
export type IMainContentHandler<T = IBigOverContent | IMainContent> = (
  params: Pick<IMainParams<T>, 'content' | 'index'>
) => void;

export interface IRankingInfo {
  ranking: number;
  delta: number | 'new';
}

/**
 * 브라우저 상에서 받은 url 과 실제 탭에서 사용하는 key 가 다른 경우 매핑하기 위함(예: main?tab=free-today -> 내부키: free_publishing)
 */
export const RAW_TAB_TO_TAB_KEY: Record<string, IMainSecondTab> = {
  'free-today': 'free_publishing',
  waifree: 'waitfree',
};
